function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext } from 'react';
import CompareContext, { CompareContextOverride } from '../RecordObject/RecordCompareContext';
import ObjectRow from '../RecordObject/RecordCompareObjectRow';
import ArrayGroup from '../RecordObject/RecordCompareArrayGroup';
import ObjectGroup from '../ObjectGroup/ObjectGroup';
import LayoutGroup from '../LayoutGroup/LayoutGroup';
import { findSchemaProperty } from '../../util/recordCompareRecordObject';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import ArrayCard from '../RecordObject/CardView/RecordCompareArrayCard';
export default function DMLayoutGroup() {
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView;
  var _useContext2 = useContext(CompareContext),
    layout = _useContext2.layout,
    mergeRecord = _useContext2.mergeRecord,
    records = _useContext2.records,
    isSelectable = _useContext2.isSelectable;
  return /*#__PURE__*/React.createElement(React.Fragment, null, layout.map(function (_ref) {
    var id = _ref.id,
      type = _ref.type;
    var _findSchemaProperty = findSchemaProperty(id, type, mergeRecord, records),
      _findSchemaProperty2 = _slicedToArray(_findSchemaProperty, 2),
      selectable = _findSchemaProperty2[0],
      childType = _findSchemaProperty2[1];
    var child;
    switch (childType) {
      case 'field':
        child = /*#__PURE__*/React.createElement(ObjectRow, {
          property: id
        });
        break;
      case 'object':
        child = /*#__PURE__*/React.createElement(ObjectGroup, {
          property: id
        });
        break;
      case 'group':
        child = /*#__PURE__*/React.createElement(LayoutGroup, {
          property: id
        });
        break;
      case 'array':
        child = !cardView ? /*#__PURE__*/React.createElement(ArrayGroup, {
          property: id
        }) : /*#__PURE__*/React.createElement(ArrayCard, {
          layoutRowId: id
        });
        break;
      default:
        child = undefined;
        break;
    }
    return /*#__PURE__*/React.createElement(CompareContextOverride, {
      key: "".concat(childType, ".").concat(id),
      isSelectable: isSelectable && selectable
    }, child);
  }));
}